import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

const defaultProps = {
  width: 18,
  height: 18,
};

const EnvelopeIcon = props => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
    >
      <defs>
        <path id="a" d="M0 0h18v18H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          fill="#4D4D4D"
          d="M1 4v10h16V4H1zm8 6.175L2.438 4.742h13.124L9 10.175zM6.386 8.998l-4.6 3.808V5.19l4.6 3.808zm.596.494L9 11.162l2.018-1.67 4.549 3.766H2.433l4.549-3.766zm4.632-.494l4.6-3.808v7.616l-4.6-3.808z"
          mask="url(#b)"
        />
      </g>
    </svg>
  );
};

EnvelopeIcon.propTypes = propTypes;
EnvelopeIcon.defaultProps = defaultProps;

export default EnvelopeIcon;
